import { DictionaryNamesEnum } from '../enums/DictionaryNamesEnum';
import { DictionaryStatusesEnum } from '../enums/DictionaryStatusesEnum';
import { IDictionariesState } from '../interfaces/IDictionariesState';

export const initialDictionariesState: IDictionariesState = {
  federalLawsStatus: DictionaryStatusesEnum.IDLE,
  federalLaws: null,
  filteredFederalLaws: null,
  knmSubjectTypesStatus: DictionaryStatusesEnum.IDLE,
  knmSubjectTypes: null,
  knoSupervision: {},
  eventUuids: {},
  eventHasUnplannedActivity: {},
  itemsList: {
    data: [],
    status: DictionaryStatusesEnum.IDLE,
  },
  items: {
    [DictionaryNamesEnum.ACCEPTED_DOCUMENT]: {},
    [DictionaryNamesEnum.ERVK]: {},
    [DictionaryNamesEnum.CHECKLIST]: {},
    [DictionaryNamesEnum.EVENT_TYPE]: {},
    [DictionaryNamesEnum.PM_PROF_EVENT_TYPE]: {},
    [DictionaryNamesEnum.KNM_KIND]: {},
    [DictionaryNamesEnum.KNO_ORGANIZATIONS]: {
      data: undefined,
      status: DictionaryStatusesEnum.IDLE,
    },
    [DictionaryNamesEnum.POSITIONS]: {},
    [DictionaryNamesEnum.PERMIT_DOCS]: {},
    [DictionaryNamesEnum.PARTICIPANT_POSITIONS]: {},
    [DictionaryNamesEnum.PROF_KIND]: {},
    [DictionaryNamesEnum.REQUIREMENT]: {},
    [DictionaryNamesEnum.RISK_CATEGORY]: {},
    [DictionaryNamesEnum.DANGER_CLASS]: {},
    [DictionaryNamesEnum.RISK_INDICATORY]: {},
    [DictionaryNamesEnum.TARGET_ENTITY]: {},
    [DictionaryNamesEnum.TARGET_ENTITY_FOUNDER]: {},
    [DictionaryNamesEnum.SUBJECT_KIND]: {},
    [DictionaryNamesEnum.SUBJECT_SUB_KIND]: {},
    [DictionaryNamesEnum.SUBJECT_TYPE]: {},
    [DictionaryNamesEnum.SUPERVISION_TYPE]: {},
    [DictionaryNamesEnum.SUPERVISION_TYPE_BY_SUBJECT_TYPE]: {},
    [DictionaryNamesEnum.FEDERAL_LAWS]: {},
    [DictionaryNamesEnum.KNO_LEVELS]: {},
    [DictionaryNamesEnum.KNM_SUBJECT_TYPES]: {},
    [DictionaryNamesEnum.KNM_TYPES]: {},
    [DictionaryNamesEnum.DECISION_KIND]: {},
    [DictionaryNamesEnum.DECISION_KIND_ALL]: {},
    [DictionaryNamesEnum.ERVK_CHECK_LIST]: {},
    [DictionaryNamesEnum.CONDITION_TYPES]: {},
    [DictionaryNamesEnum.APPLICATION_CONDITION_SUBJECTS]: {},
  },
  itemsValues: {},
  itemValue: {
    [DictionaryNamesEnum.ERVK]: {},
    [DictionaryNamesEnum.ACCEPTED_DOCUMENT]: {},
    [DictionaryNamesEnum.CHECKLIST]: {},
    [DictionaryNamesEnum.EVENT_TYPE]: {},
    [DictionaryNamesEnum.PM_PROF_EVENT_TYPE]: {},
    [DictionaryNamesEnum.KNM_KIND]: {},
    [DictionaryNamesEnum.KNO_ORGANIZATIONS]: {},
    [DictionaryNamesEnum.POSITIONS]: {},
    [DictionaryNamesEnum.PERMIT_DOCS]: {},
    [DictionaryNamesEnum.FEDERAL_LAWS]: {},
    [DictionaryNamesEnum.PARTICIPANT_POSITIONS]: {},
    [DictionaryNamesEnum.PROF_KIND]: {},
    [DictionaryNamesEnum.REQUIREMENT]: {},
    [DictionaryNamesEnum.RISK_CATEGORY]: {},
    [DictionaryNamesEnum.DANGER_CLASS]: {},
    [DictionaryNamesEnum.RISK_INDICATORY]: {},
    [DictionaryNamesEnum.TARGET_ENTITY]: {},
    [DictionaryNamesEnum.TARGET_ENTITY_FOUNDER]: {},
    [DictionaryNamesEnum.SUBJECT_KIND]: {},
    [DictionaryNamesEnum.SUBJECT_SUB_KIND]: {},
    [DictionaryNamesEnum.SUBJECT_TYPE]: {},
    [DictionaryNamesEnum.SUPERVISION_TYPE]: {},
    [DictionaryNamesEnum.SUPERVISION_TYPE_BY_SUBJECT_TYPE]: {},
    [DictionaryNamesEnum.KNO_LEVELS]: {},
    [DictionaryNamesEnum.KNM_SUBJECT_TYPES]: {},
    [DictionaryNamesEnum.KNM_TYPES]: {},
    [DictionaryNamesEnum.DECISION_KIND]: {},
    [DictionaryNamesEnum.DECISION_KIND_ALL]: {},
    [DictionaryNamesEnum.ERVK_CHECK_LIST]: {},
    [DictionaryNamesEnum.CONDITION_TYPES]: {},
    [DictionaryNamesEnum.APPLICATION_CONDITION_SUBJECTS]: {},
  },
};
